export const ESTIMATED_COST_MAX_AMOUNT = 999999999999;

export const GET_PROJECT_REQUEST_TOTALS_QUERY_VARIABLES_KEY =
  'get-project-request-totals-query-variables';

export const GET_PAGE_OF_PROJECT_REQUESTS_QUERY_VARIABLES_KEY =
  'get-page-of-project-requests-query-variables';
